import { NavDropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { languages } from '../constant/header.constant';
import { ChevronDownIcon, English, Swedish } from './images/svg/icons';

interface ContractLanguageDropdownProps {
    value: string;
    onChange: (lang: string) => void;
}
export function ContractLanguageDropdown({ value, onChange }: ContractLanguageDropdownProps) {
    const { t } = useTranslation();

    return (
        <NavDropdown
            title={
                <div className="nav-dropdown">
                    <span className="d-flex align-items-center">
                        <img src={value === 'en-us' ? English : Swedish} alt="Language" />
                    </span>
                    <span>{value === 'en-us' ? t('ENGLISH') : t('SWEDISH')}</span>
                    <img src={ChevronDownIcon} alt="Chevron" />
                </div>
            }
            id="contract-language-dropdown"
            align="end"
            className=""
        >
            {languages.map((language) => (
                <NavDropdown.Item
                    key={language.code}
                    href="#"
                    className="bg-light border-0"
                    onClick={() => onChange(language.code)}
                >
                    <div className="d-flex align-items-center py-2 pr-0">
                        {language.icon}
                        <span className="mx-2 gap-2">{t(language.label)}</span>
                    </div>
                </NavDropdown.Item>
            ))}
        </NavDropdown>
    );
}
